import { SHOW_ERROR_PAGE } from '../actions';

export default (state = false, action) => {
  switch (action.type) {
    case SHOW_ERROR_PAGE:
      return true;
    default:
      return state;
  }
};
